export default function getFieldsConfigFromCol(tab, col) {
  if (tab.children[col]) {
    return tab.children[col]
  }
  return []
}